import PropTypes from 'prop-types'
import classNames from 'classnames'
import { BranchMixin } from 'legacy/libs/baobab-react-mixins'
import BaobabPropTypes from 'legacy/libs/baobab-prop-types'
import createReactClass from 'create-react-class'

import { tabClassName, activeTabClassName } from 'common'

export default createReactClass({
  displayName: 'TabLink',

  mixins: [BranchMixin],

  propTypes: {
    className: PropTypes.string,
    name: PropTypes.string,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    cursor: BaobabPropTypes.cursor,
    children: PropTypes.node,
  },

  cursors(props) {
    return {
      current: this.props.cursor,
    }
  },

  onTabClick() {
    const { name, disabled, onClick } = this.props

    if (!disabled) {
      this.cursors.current.set(name)

      if (onClick) {
        onClick()
      }
    }
  },

  render() {
    const { current } = this.state
    const { className: customClassName, name, children, disabled } = this.props

    return (
      <button
        className={classNames(tabClassName, customClassName, {
          [activeTabClassName]: current === name,
          'text-primary': current !== name,
          'cursor-default text-black/25 hover:!decoration-transparent hover:!shadow-none':
            disabled,
        })}
        onClick={this.onTabClick}
        type="button"
      >
        {children}
      </button>
    )
  },
})
